/**
 * Ring-buffer + console E2E diagnostics. Never logs plaintext or private keys.
 */

const MAX = 200;
const buffer = [];
let seq = 0;
let flushTimer = null;
const pending = [];

const safeHeader = (header) => {
  if (!header || typeof header !== 'object') return null;
  return {
    type: header.type || null,
    n: header.n,
    pn: header.pn,
    dh: typeof header.dh === 'string' ? header.dh.slice(0, 12) : null,
    spk_id: header.spk_id ?? null,
    opk_id: header.opk_id ?? null,
  };
};

const safeState = (state) => {
  if (!state) return null;
  return {
    established: Boolean(state.established),
    hasCKs: Boolean(state.CKs),
    hasCKr: Boolean(state.CKr),
    Ns: state.Ns ?? null,
    Nr: state.Nr ?? null,
    PN: state.PN ?? null,
    DHr: state.DHr ? 'yes' : null,
    pendingPrekey: Boolean(state.pendingPrekey),
  };
};

export const e2eLog = (event, details = {}) => {
  const entry = {
    seq: ++seq,
    ts: new Date().toISOString(),
    event: String(event || 'event'),
    chat: details.chatId ? String(details.chatId).slice(0, 8) : null,
    msg: details.msgId ? String(details.msgId).slice(0, 8) : null,
    err: details.err ? String(details.err).slice(0, 180) : null,
    header: safeHeader(details.header),
    state: safeState(details.state),
    extra: details.extra && typeof details.extra === 'object' ? details.extra : undefined,
  };
  buffer.push(entry);
  if (buffer.length > MAX) buffer.shift();
  try {
    // eslint-disable-next-line no-console
    console.info('[e2e]', entry.event, entry);
  } catch (_) {
    // ignore
  }
  pending.push(entry);
  if (!flushTimer) {
    flushTimer = setTimeout(flushToServer, 800);
  }
};

export const getE2ELogBuffer = () => buffer.slice();

const flushToServer = async () => {
  flushTimer = null;
  if (!pending.length) return;
  // Server accepts max 50 events; oversized batches → 422 and lost diagnostics.
  const batch = pending.splice(0, 50);
  try {
    const { e2eAPI } = await import('../../api');
    await e2eAPI.postClientLogs(batch);
  } catch (_) {
    // non-fatal — re-queue for a later flush
    pending.unshift(...batch);
    if (pending.length > MAX) {
      pending.splice(0, pending.length - MAX);
    }
  }
  if (pending.length && !flushTimer) {
    flushTimer = setTimeout(flushToServer, 1200);
  }
};
